export default [
  {
    key: 'serviceCap',
    label: 'field.serviceCap',
    type: 'tel',
    rules: 'required',
    icon: 'icon',
    hiddenKey: 'isBot',
    hiddenValue: true,
    tooltipContent: 'noteForServiceCap',
    cols: 6,
  },
  {
    key: 'email',
    label: 'field.email',
    type: 'text',
    // rules: 'required|email|max:100|company_email',
    rules: 'required|email|max:100',
    cols: 6,
  },
  {
    key: 'roleId',
    label: 'field.role',
    rules: 'required',
    type: 'async-single-selection',
    repository: 'role',
    selectionKey: 'id',
    selectionLabel: 'name',
    cols: 6,
  },
  {
    key: 'serviceCap',
    label: 'field.serviceCap',
    type: 'tel',
    rules: 'required',
    icon: 'icon',
    cols: 6,
  },
  {
    key: 'projectId',
    label: 'breadcrumb.project',
    type: 'async-multi-selection',
    repository: 'project',
    selectionKey: 'id',
    selectionLabel: 'translations',
    rules: 'required',
    cols: 6,
  },
  {
    key: 'departmentId',
    label: 'breadcrumb.department',
    type: 'async-single-selection',
    repository: 'department',
    selectionKey: 'id',
    selectionLabel: 'name',
    rules: 'required',
    cols: 6,
  },
  {
    key: 'teamId',
    label: 'breadcrumb.team',
    type: 'async-multi-selection',
    repository: 'team',
    selectionKey: 'id',
    selectionLabel: 'translations',
    cols: 6,
    dependency: 'departmentId',
    dependencyKey: 'departmentId',
  },
  {
    key: 'serviceCategoryCode',
    label: 'breadcrumb.serviceCategory',
    type: 'async-single-selection',
    repository: 'serviceCategory',
    selectionKey: 'code',
    selectionLabel: 'translations',
    cols: 6,
  },
  {
    key: 'serviceType',
    label: 'breadcrumb.serviceType',
    type: 'async-multi-selection',
    repository: 'serviceType',
    selectionKey: 'id',
    selectionLabel: 'translations',
    cols: 6,
    dependency: 'serviceCategoryCode',
    dependencyKey: 'code',
  },
]
